export const getVehicleTypeName = (item, t) => {
  if (typeof item?.vehicleType !== "string" || !item.vehicleType) {
    return item?.vehicleTypeName;
  }

  const key = `vehicleTypes.${item.vehicleType}`;
  const translatedName = t(key, { defaultValue: item.vehicleTypeName ?? "", returnObjects: false });

  return typeof translatedName === "string" && translatedName.trim() && translatedName !== key
    ? translatedName
    : item.vehicleTypeName;
};
